import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Box, CircularProgress, Stack } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import WorkshopHeader from './WorkshopHeader';
import WorkshopTable from './WorkshopTable';
import WorkshopModal from './WorkshopModal'
import { toast } from 'react-toastify';

const Ateliers = () => {
  const { user } = useAuth();
  const token = localStorage.getItem('token');
  const [searchTerm, setSearchTerm] = useState(''); // ✨ État pour la recherche

  const [workshops, setWorkshops] = useState([]);
  const [loading, setLoading] = useState(true);
  // 1. Ajoute ces deux états en haut de ton composant Ateliers
   const [openModal, setOpenModal] = useState(false);
  const [selectedWorkshop, setSelectedWorkshop] = useState(null);

  // Fonction pour ajouter (vide)
  const handleAdd = () => {
    setSelectedWorkshop(null);
    setOpenModal(true);
  };

  // Fonction pour modifier (rempli)
  const handleEdit = (workshop) => {
    setSelectedWorkshop(workshop);
    setOpenModal(true);
  };
  // Utilisation de useCallback comme pour vos catégories
  const fetchWorkshops = useCallback(async () => {
    setLoading(true);
    try {
      // Détermination du préfixe selon le rôle
      const rolePath = user?.role === 3 ? 'intervenant' : 'admin';

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/${rolePath}/atelier/g/l/list`, // Adapté à votre route
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      // Adaptation à la structure de réponse : res.data.result
      setWorkshops(res.data.result || []);
    } catch (err) {
      console.error('Erreur lors de la récupération des ateliers:', err);
    } finally {
      setLoading(false);
    }
  }, [user?.role, token]);

  useEffect(() => {
    if (user && token) {
      fetchWorkshops();
    }
  }, [fetchWorkshops, user, token]);

  const filteredWorkshops = workshops.filter((ws) => {
    const searchLower = searchTerm.toLowerCase();
    const titleMatch = ws.title_ws?.toLowerCase().includes(searchLower);
    const intervenantMatch =
      `${ws.intervenant?.nom_user} ${ws.intervenant?.prenom_user}`
        .toLowerCase()
        .includes(searchLower);

    return titleMatch || intervenantMatch;
  });

  const handleDeleteWorkshop = async (idWs) => {
    try {
      const rolePath = user?.role === 3 ? 'intervenant' : 'admin';

      // 🚀 Appel de votre route DELETE
      const res = await axios.delete(
        `${process.env.REACT_APP_API_URL}/${rolePath}/atelier/meet/d/delete/${idWs}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (res.data.status === 'success') {
        toast.success('Atelier supprimé avec succès');
        fetchWorkshops(); // Rafraîchir la liste
      } else {
        toast.error(res.data.message || 'Erreur lors de la suppression');
      }
    } catch (err) {
      toast.error(err.response?.data?.message || 'Erreur serveur');
    }
  };
  return (
     <Box sx={{ p: 4 }}>
      <WorkshopHeader 
        count={filteredWorkshops.length}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        onAddNew={handleAdd} // ✨ On passe la fonction d'ajout
      />

      <WorkshopTable 
        data={filteredWorkshops} 
        onDelete={handleDeleteWorkshop}
        onEdit={handleEdit} // ✨ On passe la fonction de modif à la table
      />

      {/* ✨ LA MODAL EST MAINTENANT ICI */}
      <WorkshopModal 
        open={openModal} 
        handleClose={() => setOpenModal(false)} 
        refreshData={fetchWorkshops}
        initialData={selectedWorkshop} // Les données pour l'update
        intervenantId={user?.role === 3 ? user.id : selectedWorkshop?.intervenant_id}
      />
    </Box>
  );
};

export default Ateliers;
